
<template>
    <b-tabs pills card vertical class="" v-if="general_fields.length > 0">
        <b-tab title-link-class="" :key="item.shipment_id"  :active="item.is_active"  v-for="(item,idx) in general_fields">
            <template slot="title">
                <div class="fs-lg px-4 text-center ">
                    {{ __t(item.shipment_title) }}
                </div>
            </template>

            <b-card-text>

                <yes_no
                    v-if="!is_qr"
                    key="PUBLISHED"
                    title="PUBLISHED"
                    @input="on_change_value"
                    v-model="item.published"
                >
                </yes_no>

                <div v-if="item.published">
                    <yes_no
                        key="PAY_CACHE"
                        title="PAY_CACHE"
                        @input="on_change_value"
                        v-model="item.pay_cache"
                    >
                    </yes_no>


                    <yes_no
                        key="PAY_ONLINE"
                        title="PAY_ONLINE"
                        @input="on_change_value"
                        v-model="item.pay_online"
                    >
                    </yes_no>

                    <yes_no
                        key="PAY_TERMINAL"
                        title="PAY_TERMINAL"
                        @input="on_change_value"
                        v-model="item.pay_terminal"
                    >
                    </yes_no>
                </div>


            </b-card-text>
        </b-tab>
    </b-tabs>

</template>


<script>

import yes_no from "../../../../../sys/radio/yes_no.vue";
export default {
    name: "pwa_shipment_settings",
    props : {
        location : {
            type : Object
        },
        is_qr : {
            type : Boolean,
            default : false
        }
    },
    components : {
        yes_no,
    },

    methods: {
        on_change_value(val) {

        }
    },

    computed: {

        general_fields() {

            return this.location_fields.map(item => {
                if(this.is_qr) {
                    if(parseInt(item.shipment_id) === 2) {
                        item.shipment_title = 'pwa.table';
                    }
                }
                return item;
            }).filter(item => {
                    if(this.is_qr) {
                        if (parseInt(item.shipment_id) === 2) {
                            return item;
                        }

                        return false;
                    }

                    return item;
            });
        },

        location_fields() {
            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if(key == 'shipments') {
                        return value;
                    }
                }
                return res;
            }

            return [];
        }

    }
}
</script>

<style scoped>

</style>
